/* eslint-disable no-return-await, no-console, no-param-reassign, no-trailing-spaces */
import axios from 'axios';
// import moment from 'moment';
import helper from '@/_libs/helper';

// const DATE_TODAY = moment().format('YYYY-MM-DD');

// const DATE_YESTERDAY = moment().subtract(1, 'days').format('YYYY-MM-DD');
// const DATE_3_DAYS_AGO = moment().subtract(3, 'days').format('YYYY-MM-DD');
// const DATE_LASTWEEK = moment().subtract(7, 'days').format('YYYY-MM-DD');

// const DATE_TOMORROW = moment().add(1, 'days').format('YYYY-MM-DD');

const MOCK = {
  history: {
    sellRecord: {
      items: [
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 12,
          price: 6000.04,
          total: 72000.48,
        },
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 12,
          price: 6000.04,
          total: 72000.48,
        },
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 12,
          price: 6000.04,
          total: 72000.48,
        },
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 12,
          price: 6000.04,
          total: 72000.48,
        },
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 12,
          price: 6000.04,
          total: 72000.48,
        },
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 12,
          price: 6000.04,
          total: 72000.48,
        },
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 12,
          price: 6000.04,
          total: 72000.48,
        },
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 12,
          price: 6000.04,
          total: 72000.48,
        },
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 12,
          price: 6000.04,
          total: 72000.48,
        },
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 12,
          price: 6000.04,
          total: 72000.48,
        },
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 12,
          price: 6000.04,
          total: 72000.48,
        },
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 12,
          price: 6000.04,
          total: 72000.48,
        },
      ],
    },
    quotation: {
      items: [
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 12,
          price: 6000.04,
          total: 72000.48,
        },
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 14,
          price: 6000.04,
          total: 6000.04 * 14,
        },
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 100,
          price: 6000.04,
          total: 6000.04 * 100,
        },
      ],
    },
    backOrder: {
      items: [
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 12,
          price: 6000.04,
          total: 72000.48,
        },
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 14,
          price: 6000.04,
          total: 6000.04 * 14,
        },
        {
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 100,
          price: 6000.04,
          total: 6000.04 * 100,
        },
      ],
    },
  },
};

const history = {
  async sellRecordItems(id) {
    console.log(id);
    return await helper.call('history.sellRecordItems', {
      success: true,
      data: MOCK.history.sellRecord.items,
    }, async () => await axios(helper.path('history/sell-record-items')));
  },
  async backOrderItems(id) {
    console.log(id);
    return await helper.call('history.backOrderItems', {
      success: true,
      data: MOCK.history.backOrder.items,
    }, async () => await axios(helper.path('history/back-order-items')));
  },
  async quotationItems(id) {
    console.log(id);
    return await helper.call('history.quotationItems ', {
      success: true,
      data: MOCK.history.quotation.items,
    }, async () => await axios(helper.path('history/quotation-items')));
  },

  async chatMessages(orderId) {
    console.log(orderId);
    return await helper.call('history.chatMessages ', {
      success: true,
      data: MOCK.history.quotation.items,
    }, async () => await axios(helper.path(`/api/orders/${orderId}/chat/`)));
  },
  async submitChatMessages(orderId, message) {
    console.log(orderId);
    return await helper.call('history.chatMessages ', {
      success: true,
      data: MOCK.history.quotation.items,
    }, async () => await axios.post(
      helper.path(`orders/${orderId}/chat/`),
      // data
      {
        message,
      },
    ));
  },
};

export default history;
